import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 px-4 bg-brand-warm" data-id="element-139">
      <div className="max-w-xl mx-auto" data-id="element-140">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white border-2 border-brand-gold/30 p-8 rounded-3xl text-center relative overflow-hidden shadow-sm" data-id="element-141">
          <div className="absolute top-0 right-0 w-32 h-32 bg-brand-gold/5 rounded-full blur-3xl" data-id="element-142" />
          <div className="absolute bottom-0 left-0 w-32 h-32 bg-brand-olive/5 rounded-full blur-3xl" data-id="element-143" />

          <ShieldCheckIcon className="w-16 h-16 text-brand-gold mx-auto mb-6 relative z-10" data-id="element-144" />

          <h3 className="text-2xl sm:text-3xl font-serif font-bold text-brand-text-main mb-4 relative z-10" data-id="element-145">
            PROVA SENZA ALCUN RISCHIO
          </h3>

          <p className="text-brand-text-muted text-lg font-medium leading-relaxed mb-6 relative z-10" data-id="element-146">
            Hai 7 giorni completi per esplorare ogni contenuto.
          </p>

          <p className="text-brand-text-main font-medium mb-6 relative z-10" data-id="element-147">
            Apri i Tomi. Prova una ricetta. Segui il piano.
            <br data-id="element-148" />
            Se non senti che la tua alimentazione è diventata più semplice e
            soddisfacente — ti restituiamo ogni centesimo. Senza domande.
          </p>
        </motion.div>
      </div>
    </section>;
}